import { Pin, Space } from '@/modules/defines/interface';
import { Dispatch, SetStateAction } from 'react';

interface PinPointProps {
  storedPoint: string | null;
  spaceData: Space[] | undefined;
  setZoneState: (arg0: string) => void;
  setStandardCoordData: Dispatch<
    SetStateAction<
      {
        zone: string;
        coord: number[][];
      }[]
    >
  >;
  standardCoordData: {
    zone: string;
    coord: number[][];
  }[];
  setPoint: Dispatch<SetStateAction<Pin | null>>;
}

async function getSessionPoint({
  storedPoint,
  spaceData,
  standardCoordData,
  setPoint,
}: PinPointProps) {
  if (!spaceData) return;

  if (storedPoint) {
    const parsedStart = JSON.parse(storedPoint);
    const space = spaceData.find((space: Space) => space.id === parsedStart.id);
    if (!space) return;

    const zonesOfSpace = space.zone?.split(',');
    const relevantCoords = standardCoordData
      .filter((data) => zonesOfSpace?.includes(data.zone))
      .flatMap((data) => data.coord);

    const avgX =
      relevantCoords.reduce(
        (sum: number, coord: number[]) => sum + coord[0],
        0
      ) / relevantCoords.length;
    const avgY =
      relevantCoords.reduce(
        (sum: number, coord: number[]) => sum + coord[1],
        0
      ) / relevantCoords.length;
    if (avgX && avgY) {
      setPoint({
        id: Date.now(),
        x: avgX,
        y: avgY,
        space_id: space.id,
        space_title: space.title,
        panorama_id: space.default_pano,
      });
    }
  }
}

export default getSessionPoint;
